import { render, staticRenderFns } from "./RestaurantsModuleComponent.vue?vue&type=template&id=7e19289a&scoped=true"
import script from "./RestaurantsModuleComponent.vue?vue&type=script&lang=js"
export * from "./RestaurantsModuleComponent.vue?vue&type=script&lang=js"
import style0 from "./RestaurantsModuleComponent.vue?vue&type=style&index=0&id=7e19289a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e19289a",
  null
  
)

export default component.exports